import { render, staticRenderFns } from "./QuotationIndex.vue?vue&type=template&id=21e6d1ca"
import script from "./QuotationIndex.vue?vue&type=script&lang=js"
export * from "./QuotationIndex.vue?vue&type=script&lang=js"
import style0 from "./QuotationIndex.vue?vue&type=style&index=0&id=21e6d1ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports